<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
  >

    <template #cell(period)="{ data }">
      {{ data.value.name }}
    </template>

    <template #cell(from_org)="{ data }">
      {{ $langName(data.value.name) }}
    </template>

    <template #cell(letter_status)="{ data }">
      <b-badge :variant="getLetterStatusColor(data.value)">
        {{ $langName(getLetterStatus(data.value).name) }}
      </b-badge>
    </template>

    <template #cell(letter_type)="{ data }">
      {{ $langName(getLetterType(data.value).name) }}
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-b-toggle.sidebar-create-inbox
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'inbox-view', params: { id: data.item.id }})"
        />
        <feather-icon
          icon="ArchiveIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="history(data.item)"
        />
      </div>

    </template>
  </l-table>
</template>

<script>
import {
  VBToggle, BBadge,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import inboxModule from '@/store/inbox/index'
import LTable from '@/views/components/LTable.vue'
import Inbox from '@/views/components/filters/service/Inbox'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BBadge,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    this.$store.dispatch('staticModule/letterTypes')
    this.$store.dispatch('staticModule/letterStatuses')
    this.$store.dispatch('staticModule/periodList')
    this.$store.dispatch('staticModule/organizationList')
  },
  methods: {
    getLetterType(id) {
      return this.$store.getters['staticModule/getLetterType'](id)
    },
    getLetterStatus(id) {
      return this.$store.getters['staticModule/getLetterStatus'](id)
    },
    getLetterStatusColor(id) {
      return this.$store.getters['staticModule/getLetterStatusColor'](id)
    },
    history(letter) {
      this.$router.push({
        name: 'inbox-history',
        params: { id: letter.id },
      })
    },
  },
  setup() {
    const MODULE_NAME = 'inbox'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, inboxModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    const filterClass = new Inbox()
    return {
      MODULE_NAME,
      filterClass,
      ...config(),
    }
  },
}
</script>
